module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/сommode-1-65360bd34510cfae189b5291dcbca5a8.svg";